/* global AV, soundManager */

import constants from '../../../constant/appConst'
import { AudioPlayer } from './AudioPlayer'

import 'soundmanager2/script/soundmanager2-nodebug-jsmin'

soundManager.setup({ ignoreMobileRestrictions: true })

let playerWrapper = { type: null, player: null, currentTime: 0, currentPercentAVBuffer: 0, trackDuration: 0 }

/**
 *
 * Gestionnaire de lecture audio sans aucune logique autre que la lecture audio de navigateur web, et de callbacks
 *
 */

export default class WebAudioPlayer extends AudioPlayer {

	load(trackData, fileUrlData, autoPlay = true, initialSeek = 0, volume = 100) {
		super.load(trackData, fileUrlData, autoPlay, initialSeek, volume)

		this.closeMusic()

		playerWrapper.currentTime = 0
		playerWrapper.currentPercentAVBuffer = 0
		playerWrapper.trackDuration = fileUrlData.duration

		this.onProgressChanged(0)
		this.onBufferChanged([{
			start: 0,
			end: 0
		}])

		const self = this


		this.onLoadedTrack()

		playerWrapper.type = 'soundmanager'
		playerWrapper.player = soundManager.createSound({
			url: fileUrlData.url,
			autoLoad: true,
			onload() {
				if (autoPlay) {
					self.play()
				}
			},
			onbufferchange(isBuffering) {
				if (isBuffering) {
					// console.log('start buffering')
					self.onBuffering()
				} else {
					// console.log('end buffering')
					self.onBufferingEnded()
				}
			},
			whileloading() {
				// console.log('while loading')
				self.onBufferChanged(this.buffered) // ex : [{ start: 0, end: 2 }, { start: 5, end: 7 }]
			},
			whileplaying() {
				const timestamp = this.position / 1000
				if (self._trackTimeBuffered()) {
					self.onBufferingEnded()
				} else {
					self.onBuffering()
				}
				if (Math.floor(playerWrapper.currentTime) !== Math.floor(timestamp)) {
					// console.log('while playing', timestamp)
					playerWrapper.currentTime = timestamp
					self.onProgressChanged(timestamp)
					self._handleProgressEnd()
				}
			},
			onfailure() {
				console.log('fail !')
			},
			onplay() {
				self.onPlayedTrack()
			},
			onfinish() {
				self.stop()
				self.onTrackEnded()
			}
		})

		if (autoPlay) {
			this.play(true)
		}

		self.seek(0)
		self.setVolume(volume)
		// }
	}

	_getBufferingTimestamp() {
		return (playerWrapper.currentPercentAVBuffer * playerWrapper.trackDuration) / 100
	}

	_trackTimeBuffered() {
		let inBuffered = false
		if (playerWrapper.type === 'soundmanager') {
			let i
			let j
			for (i = 0, j = playerWrapper.player.buffered.length; i < j; i++) {
				if (playerWrapper.currentTime >= playerWrapper.player.buffered[i].start &&
					playerWrapper.currentTime <= playerWrapper.player.buffered[i].end) {
					inBuffered = true
				}
			}
		} else if (playerWrapper.type === 'aurora') {
			if (playerWrapper.currentTime <= this._getBufferingTimestamp()) {
				inBuffered = true
			}
		}
		return inBuffered
	}

	_handleProgressEnd() {
		const dSec = constants.timeForGaplessPreload
		const inBuffered = this._trackTimeBuffered()
		if (inBuffered && playerWrapper.currentTime >= playerWrapper.trackDuration - dSec) {
			this.onTrackEndComing()
		} else if (!inBuffered && playerWrapper.currentTime >= playerWrapper.trackDuration) {
			this.stop()
			this.onTrackEnded()
		}
	}

	closeMusic() {
		if (playerWrapper.player) {
			this.stop()

			delete(playerWrapper.player)
			playerWrapper = null
		}
		playerWrapper = { type: null, player: null, currentTime: 0, currentPercentAVBuffer: 0, trackDuration: 0 }
	}

	play(dontPlay) {
		// console.log('play')
		if (!dontPlay) {
			playerWrapper.player.play()
		}
		if (this._trackTimeBuffered()) {
			this.onBufferingEnded()
		} else {
			this.onBuffering()
		}
		this.onPlayedTrack()
	}

	stop() {
		// console.log('stop', playerWrapper.player)
		playerWrapper.player.stop()
		if (playerWrapper.type === 'soundmanager') {
			playerWrapper.player.unload()
		}
		this.onProgressChanged(0)
		this.onBufferChanged([{
			start: 0,
			end: 0
		}])
		this.onPausedTrack()
	}

	pause() {
		// console.log('pause')
		playerWrapper.player.pause()
		this.onPausedTrack()
	}

	seek(position) {
		// console.log('seek', position)
		let response
		if (playerWrapper.type === 'aurora') {
			response = false
		} else if (playerWrapper.type === 'soundmanager') {
			playerWrapper.player.setPosition(position * 1000)
			response = true
		}
		return response
	}

	setVolume(volume) {
		if (playerWrapper.type === 'aurora') {
			playerWrapper.player.volume = volume
		} else if (playerWrapper.type === 'soundmanager') {
			playerWrapper.player.setVolume(volume)
		}
	}

	prepareNextTrack(trackData, fileUrlData) {
		super.prepareNextTrack(trackData, fileUrlData)

		this.onPreparedNextTrack()
	}

	switchNextTrack() {
		let response = null
		if (this.nextTrackData) {
			response = {
				trackData: this.nextTrackData,
				fileUrl: this.nextFileUrlData
			}
			this.load(this.nextTrackData, this.nextFileUrlData, true, 0, 100)
		}
		this.onSwitchedNextTrack(response)

		return response
	}
}



// WEBPACK FOOTER //
// ./src/components/miniPlayer/AudioPlayer/WebAudioPlayer.js